// frontend/src/components/dashboard/PanelHeading.js
//
// The same heading on every panel.
//
// The page had five panels and five different headings: some an h6 in near
// black with a grey sentence under it, some an h6 alone, one with a chip
// floated right and one with nothing at all. Read down the page, nothing
// signalled "a new section starts here" consistently, so the panels ran into
// each other and the eye had to re-learn the layout at every step.
//
// Small, heavy, spaced and in the company green — the same treatment as the
// section headings on the reports and the emails these managers already read.

import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

const DEEP = '#034f2d';

export default function PanelHeading({ title, caption, right, sx }) {
  return (
    <Stack
      direction="row"
      alignItems={caption ? 'flex-start' : 'center'}
      justifyContent="space-between"
      spacing={1}
      sx={{ minWidth: 0, ...sx }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: 11.5,
            fontWeight: 900,
            letterSpacing: 0.7,
            textTransform: 'uppercase',
            color: DEEP,
            lineHeight: 1.3,
          }}
        >
          {title}
        </Typography>

        {caption ? (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pt: 0.15 }}>
            {caption}
          </Typography>
        ) : null}
      </Box>

      {right ? <Box sx={{ flexShrink: 0 }}>{right}</Box> : null}
    </Stack>
  );
}
